import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, KeepAlive as _KeepAlive, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { style: {"position":"absolute","bottom":"5px"} }
const _hoisted_2 = { class: "layout-main-container" }
const _hoisted_3 = { class: "flex-grow" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoginSkin = _resolveComponent("LoginSkin")!
  const _component_Login = _resolveComponent("Login")!
  const _component_AppTopBar = _resolveComponent("AppTopBar")!
  const _component_AppMenu = _resolveComponent("AppMenu")!
  const _component_Button = _resolveComponent("Button")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_AppFooter = _resolveComponent("AppFooter")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.isAuthenticated)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_LoginSkin),
          _createVNode(_component_Login)
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.isAuthenticated && _ctx.canAccessRoute)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(_ctx.containerClass),
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onWrapperClick && _ctx.onWrapperClick(...args)))
        }, [
          _createVNode(_component_AppTopBar, {
            onMenuToggle: _ctx.onMenuToggle,
            onLogout: _ctx.logout,
            onRefreshApp: _ctx.refreshApp,
            email: _ctx.email
          }, null, 8, ["onMenuToggle", "onLogout", "onRefreshApp", "email"]),
          (_ctx.isInternalUser)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "layout-sidebar",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onSidebarClick && _ctx.onSidebarClick(...args)))
              }, [
                _createVNode(_component_AppMenu, {
                  model: _ctx.menu,
                  onMenuitemClick: _ctx.onMenuItemClick
                }, null, 8, ["model", "onMenuitemClick"]),
                _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
                _createVNode(_component_Button, {
                  label: "Logout",
                  onClick: _ctx.logout
                }, null, 8, ["onClick"]),
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("small", null, _toDisplayString(this.$store.getters.localStorageSize), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_router_view, null, {
                default: _withCtx(({Component}) => [
                  (_openBlock(), _createBlock(_KeepAlive, { include: "CustomerList,SupplierList,OwnerList,AuthorityList,AllCompanyList,Dashboard,PropertyList,MailingList" }, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                  ], 1024))
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_AppFooter)
          ]),
          _createVNode(_component_ConfirmDialog)
        ], 2))
      : _createCommentVNode("", true),
    _createVNode(_component_Toast)
  ], 64))
}